import { Hoja } from "@/components/Hoja";
import { TERMINOS } from "@/lib/legal";
import { LegalDoc } from "@/components/LegalDoc";

export default function Terminos() {
  return (
    <Hoja testId="screen-terminos" title="Términos y condiciones">
      <LegalDoc text={TERMINOS} testId="terms-text" />
    </Hoja>
  );
}
